import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';

/**
 * Query key factory for leaderboard
 */
export const leaderboardKeys = {
  all: ['leaderboard'] as const,
  pool: (poolId: string) => [...leaderboardKeys.all, poolId] as const,
};

/**
 * Hook to get the leaderboard for a pool
 */
export function useLeaderboard(poolId: string) {
  return useQuery({
    queryKey: leaderboardKeys.pool(poolId),
    queryFn: async () => {
      const response = await api.leaderboard.getLeaderboard(poolId);
      if (response.error) {
        throw new Error(response.error.message);
      }
      // Ensure we always return an array to prevent .filter crashes
      return Array.isArray(response.data) ? response.data : [];
    },
    enabled: !!poolId,
    staleTime: 1000 * 30, // 30 seconds
  });
}
